import { render, staticRenderFns } from "./GStudentRecordRecommendationLetterModal.vue?vue&type=template&id=7d706ab8&scoped=true&"
import script from "./GStudentRecordRecommendationLetterModal.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordRecommendationLetterModal.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordRecommendationLetterModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GStudentRecordRecommendationLetterModal.vue?vue&type=style&index=1&id=7d706ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d706ab8",
  null
  
)

export default component.exports